import React from 'react';
import { useTranslations } from '@/shared/ui/selects/select-options/hooks';
import { TermsCard } from './styles'
import { StepsList } from '../bonus-conditions/styles';
import { BodyTextMediumA, BodyTextRegularB } from '@/shared/ui/typography2';

export const TermsAndConditions = () => {
  const { translations } = useTranslations();
  const parts = translations?.bonus?.page_content?.terms_and_conditions?.parts;
  const firstPart = Array.isArray(parts) ? parts[0] : null;

  if (!firstPart) return null;

  const terms = firstPart.list || [];

  return (
    <TermsCard>
      <BodyTextMediumA style={{fontWeight: 700}}>
        {firstPart.template}
      </BodyTextMediumA>

      <StepsList>
        {terms.map((term, index) => (
          <li key={index}>
            <BodyTextRegularB color='#AFAFAF'>
              {term}
            </BodyTextRegularB>
          </li>
        ))}
      </StepsList>
    </TermsCard>
  );
};
